import xss from "xss";
import CurrencyItem from "../type/currency-item.js";

const mapCurrency = (c) => {
  return {
    iso: xss(String(c.iso).toLowerCase()),
    symbol: xss(c.symbol),
    popularity: Number(
      c.additionalProperties && c.additionalProperties.popularity
        ? c.additionalProperties.popularity
        : "99999"
    )
  };
};

export default class CurrenciesStorage {
  constructor(config) {
    let { all, current, timestamp, priceList } = config || {};
    this.all = all || [];
    this.current = current || [];
    this.priceList = priceList || {};
    this.timestamp = timestamp || null;
  }

  setAll(data) {
    if (!data || !Array.isArray(data.items)) return;
    this.all = data.items.map(mapCurrency);
    if (this.priceList) {
      this.setAvailable(this.priceList.list, this.priceList.timestamp);
      this.priceList = null;
    }
  }

  setAvailable(list, cTimestamp) {
    if (!Array.isArray(list)) return;
    if (this.hasNoData()) {
      // store arguments if katalog is not yet loaded
      this.priceList = { list, timestamp: cTimestamp };
      return;
    }
    this.timestamp = xss(cTimestamp);
    let stueckelung;
    let isoList = this.all.map((c) => c.iso);
    // creating lists of available items
    const oldList = this.current || [];
    this.current = list
      .filter((c) => isoList.includes(String(c.isoCode).toLowerCase()))
      .map((c) => {
        let iso = String(c.isoCode).toLowerCase();
        const sorte = this.all.find((a) => a.iso === iso);
        stueckelung = String(c.stueckelungen)
          .split(",")
          .filter((d) => !!d)
          .map((d) => Number(d))
          .filter((d) => !isNaN(d))
          .sort((a, b) => {
            if (a === b) return 0;
            return a < b ? -1 : 1;
          });
        const newItem = CurrencyItem.create({
          kennziffer: c.kennziffer,
          id: iso + c.kennziffer,
          name: c.bezeichnung,
          symbol: sorte.symbol,
          iso: iso,
          rate: c.kurs,
          denomination: stueckelung,
          innenProvision: c.innen_provision,
          minDenomination: c.kleinsteStueckelung,
          positionDues: 0,
          positionSum: 0,
          popularity: sorte.popularity,
          produktInfo: c.produktInfo,
        });
        const oldItem = oldList.find(i => i.kennziffer === newItem.kennziffer);
        if (oldItem && oldItem.amount) {
          newItem.selectedIso = oldItem.selectedIso;
          newItem.setSelectedDenomination(oldItem.selectedDenomination);
          newItem.euroShown = oldItem.euroShown;
          newItem.setAmount(oldItem.amount);
        }
        return newItem;
      });
    // use id as image if multipe iso
    isoList
      .map(iso => this.current.filter(c => c.iso === iso))
      .filter(l => l.length > 1)
      .forEach(items => {
        items.forEach(item => { item.image = item.id + ".png"; });
      });
  }

  getItems() {
    return this.current;
  }

  getAvailableByIso(iso) {
    iso = String(iso).toLowerCase();
    return this.current.find((c) => c.iso === iso);
  }

  getCatalogTimestamp() {
    return this.timestamp;
  }

  hasNoData() {
    return this.all.length === 0 && this.current.length === 0;
  }

  hasNoAvailable() {
    return this.current.length === 0;
  }

  getQueryItems(query) {
    return (this.current || []).filter((item) => {
      return (
        this.isTextMatch(item.iso, query) || this.isTextMatch(item.name, query) || this.isTextMatch(item.id, query)
      );
    });
  }

  isTextMatch(txt, query) {
    return txt === ""
      ? false
      : txt.toLowerCase().indexOf(query.toLowerCase()) > -1;
  }
}
